export default __webpack_public_path__ + "static/media/icon-2.6873ac13.png";